import { FormApi } from 'final-form'
import { StudioSystemType } from 'types/global'
import { DropdownInput, IntegrationData, NativeMountingInputs, TextFieldInput } from 'types/mounting'
import { getRoofHookCalculationMethodInputs } from '../../Inputs'
import { ComptibilityRules, FilterCriteria, filterOptions, RoofTypeCompatibility } from '../../inputFilters'

export function createK2UKInputs(roofTypeName: string | null) {
  return (projectForm: FormApi, system: StudioSystemType): NativeMountingInputs => {
    const integrationData = system.integration_json?.k2OnRoofUK as IntegrationData

    // Get roof hook calculation method and mounting spacing inputs
    const roofHookInputs = getRoofHookCalculationMethodInputs(system, false)

    // Base options - always include Minirail, Single Rail, and Solid Rail
    const baseOptions = [
      { label: 'Minirail', value: 'minirail' },
      { label: 'Single Rail', value: 'singleRail' },
      { label: 'Solid Rail', value: 'solidRail' },
    ]

    const multiRailOptions = [
      { label: 'MultiRail 10', value: 'multiRail10' },
      { label: 'MultiRail 25', value: 'multiRail25' },
      { label: 'MultiRail 10 CSM', value: 'multiRail10CSM' },
      { label: 'MultiRail 25 CSM', value: 'multiRail25CSM' },
    ]

    const dropdownInputs: DropdownInput[] = [
      {
        label: 'Rail Type',
        variableName: 'k2UKRailType',
        default: 'minirail',
        options: [...baseOptions, ...multiRailOptions],
      },
      ...(roofHookInputs.dropdownInputs || []),
    ]

    const singleRailCompatibleRoofTypes: string[] = [
      'Tar and Gravel / Bitumen',
      'Tile Clay',
      'Tile Concrete',
      'Tile Slate',
      'Composition / Asphalt Shingle',
    ]

    const solidRailCompatibleRoofTypes: string[] = ['Tile Clay', 'Tile Concrete', 'Tile Slate']

    const compatibilityRules: ComptibilityRules = {
      k2UKRailType: {
        roofTypeCompatibility: {
          minirail: ['Trapezoidal'],
          singleRail: singleRailCompatibleRoofTypes,
          solidRail: solidRailCompatibleRoofTypes,
          multiRail10: ['Trapezoidal'],
          multiRail25: ['Trapezoidal'],
          multiRail10CSM: ['Metal Tin'],
          multiRail25CSM: ['Metal Tin'],
        } as RoofTypeCompatibility,
      },
    }

    // Create filter criteria based on current roof type
    const filterCriteria: FilterCriteria[] = [
      {
        filterType: 'roofTypeCompatibility',
        filterValue: roofTypeName || '',
      },
    ]

    // Filter dropdown options based on roof type compatibility
    const filteredDropdownInputs = filterOptions(dropdownInputs, compatibilityRules, filterCriteria, integrationData)

    const textFieldInputs: TextFieldInput[] = [...(roofHookInputs.textFieldInputs || [])]

    return {
      dropdownInputs: filteredDropdownInputs,
      textFieldInputs,
    }
  }
}
